module.exports = __webpack_public_path__ + "static/media/BreastCancerTees-thumb.a63dcb5f.jpg";